import { LexCounselGradientName, PANEL_DISPLAY, PANEL_GREETING } from './lexCounselPanelUi';

type Props = {
  name: string;
};

/** Default empty-state greeting for non-dashboard screens. */
export default function LexCounselPanelGreeting({ name }: Props) {
  return (
    <div className="mb-6">
      <p className={PANEL_GREETING}>
        Hello, <LexCounselGradientName>{name}</LexCounselGradientName>
      </p>
      <h2 className={`mt-2 ${PANEL_DISPLAY}`}>How can I help you today?</h2>
    </div>
  );
}
